import './Element'
//import 'utils/uploader-widget/main';
import '../../../../utils/uploader-widget/main'
import '../../../../utils/uploader-widget/main.js'
import 'file-icon-vectors/dist/file-icon-classic.min.css'
import 'file-icon-vectors/dist/file-icon-vivid.min.css'

NS("UI.Widget.Forms.Control");

UI.Widget.Forms.Control.Files = Class(UI.Widget.Forms.Control.Element, {
    createElement: function () {
        this.$element = $("<div>");

        setTimeout(function () {
            var value = this.getValue() || [];

			if (this.$element) {
				this.uploaderWidget = new UploaderWidget({
					container: this.$element[0],
					uploadUrl: UI.Widget.Forms.Control.Files.uploadUrl,
					downloadUrl: UI.Widget.Forms.Control.Files.downloadUrl,
					deleteUrl: UI.Widget.Forms.Control.Files.deleteUrl,
					maxQuantity: +this.$control.attr("maxq"),
					maxSize: this.$control.attr("maxs"),
					fileType: this.$control.attr("filetype"),
					context: this.$control.attr("context")
				}, value);

				this.uploaderWidget.on("change", function (files) {
					this.setValue(files);
				}.bind(this));

				this.setMode(this.mode)
			}
        }.bind(this), 0);
    },

    updateElement: function (value) {
        // ничего не делаем (переопределили родительский метод)
    },

    editMode () {
        this.ParentCall()
        this.$('[name="remove"], .btn.upload-file, .filelist-delete-img').show()
    },
    viewMode () {
        this.ParentCall()

        this.$('[name="remove"], .btn.upload-file, .filelist-delete-img').hide()
    },
});

// todo убрать хардкод в конфиг
UI.Widget.Forms.Control.Files.uploadUrl = "/Storage/Web/File/upload";
UI.Widget.Forms.Control.Files.downloadUrl = "";
UI.Widget.Forms.Control.Files.deleteUrl = "/Storage/Web/File/remove";

UI.Widget.Forms.Control.Files.renderValue = function (value) {
    var tmp = new UploaderWidget({
        container: document.createElement("div"),
        uploadUrl: UI.Widget.Forms.Control.Files.uploadUrl,
        downloadUrl: UI.Widget.Forms.Control.Files.downloadUrl,
        readonly: true
    }, value);

    return tmp.render(true).outerHTML;
};
